import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Button, Grid } from '@material-ui/core';

const AddUserForm = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    city: '',
    state: '',
    phone: '',
    email: '',
    farmSize: '',
    leadStatus: '',
  });

  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} disableEnforceFocus>
      <DialogTitle>Add New User</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="City"
              name="city"
              value={formData.city}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="State"
              name="state"
              value={formData.state}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Farm Size"
              name="farmSize"
              value={formData.farmSize}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Lead Status"
              name="leadStatus"
              value={formData.leadStatus}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Button variant="contained" color="primary" onClick={handleSubmit} style={{ marginTop: "40px", marginBottom: "10px" }}>
            Submit
          </Button>
        </Grid>

      </DialogContent>
    </Dialog>
  );
};

export default AddUserForm;